var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 24,
    viewBox: "0 0 21 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6542 23.9327C16.4962 23.3934 20.3768 19.5449 20.929 14.7305C21.6538 8.4355 16.7329 3.07692 10.5645 3.00828V0.184365C10.5645 0.0274802 10.3673 -0.0558646 10.2342 0.0421881L4.3863 4.31238C4.28768 4.38592 4.28768 4.5281 4.3863 4.60164L10.2342 8.87184C10.3673 8.96989 10.5645 8.88164 10.5645 8.72966V5.91064C14.8987 5.97928 18.3699 9.64645 18.0741 14.0294C17.8226 17.7995 14.731 20.8588 10.9393 21.099C6.92071 21.3539 3.50369 18.5006 2.89228 14.7256C2.77887 14.0245 2.16253 13.5146 1.4525 13.5146C0.56989 13.5146 -0.120417 14.2942 0.0176446 15.1619C0.875597 20.5401 5.87046 24.575 11.6542 23.9327Z",
    fill: "#43B02A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.45bc77849bf2792c842435664a1fa255.svg";
export { ForwardRef as ReactComponent };